lookupSpecifierInfo